import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import NonPurchasableMessage from "@preferredMedical/Components/NonPurchasableStatus/NonPurchasableStatusMessage";
import { getProductIsPurchasableOnWeb } from "@preferredMedical/Store/Data/Products/ProductsSelectors";
import React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState, productContext: HasProductContext) => ({
    isPurchasableOnWeb: getProductIsPurchasableOnWeb(state, productContext.productContext.product.id),
    isLoggedIn:
        (state.context.session.isAuthenticated || state.context.session.rememberMe) && !state.context.session.isGuest,
});

type Props = HasProductContext & ReturnType<typeof mapStateToProps>;

const ProductNonPurchasableMessage = ({ isPurchasableOnWeb, productContext, isLoggedIn }: Props) => {
    if (!isLoggedIn || isPurchasableOnWeb || productContext.product.isVariantParent) {
        return null;
    }

    return <NonPurchasableMessage isPurchasableOnWeb={isPurchasableOnWeb} />;
};

const widgetModule: WidgetModule = {
    component: withProductContext(connect(mapStateToProps)(ProductNonPurchasableMessage)),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
